<ng-template #rt let-r="result" let-t="term">
    <ngb-highlight [result]="r.nombre" [term]="t"></ngb-highlight>
</ng-template>

<input id="typeahead-http" type="text" class="form-control" [ngbTypeahead]="search" placeholder="Especialidades"
    [resultTemplate]="rt" [inputFormatter]="formatter" [(ngModel)]="model" (ngModelChange)="submit(null)" />